<template>
  <div class="home"
       id="hometop">
    <Topper></Topper>
    <!-- Swiper -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="swipertext">
            <span>新奥之道</span>
            <p>源自客户 伙伴平等 生态共荣</p>
          </div>
          <img src="../assets/banner1.jpg"
               alt="" />
        </div>
        <div class="swiper-slide">
          <div class="swipertext">
            <span>使命愿景</span>
            <p>
              用智能构建需供关系<br />
              打造现代能源体系 提高消费者生活品质<br />
              成为一家受人尊敬的创新型智慧企业
            </p>
          </div>
          <img src="../assets/banner3.jpg"
               alt="" />
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <!-- Swiper -->

    <!-- 新奥动态 -->
    <div class="hometit">
      <span>新奥动态</span><router-link to="/news">查看更多 ></router-link>
    </div>
    <ul class="homenews">
      <li v-for="(item, index) in newslist"
          :key="index">
        <a @click="detail(item.launchId, item.articleType, item.contentName)">
          <div class="newsdate">
            <span>{{ item.createTime.split("-")[1] }}/{{
                item.createTime.split("-")[2].split(" ")[0]
              }}</span><i>{{ item.createTime.split("-")[0] }}</i>
          </div>
          <div class="newstit">{{ item.creationTitle }}</div>
          <div class="newsintro">{{ item.creationAbstract }}</div>
        </a>
      </li>
    </ul>
    <!-- 业务模块 -->
    <div class="hometit"><span>业务布局</span></div>
    <ul class="homebusi">
      <li>
        <div class="homebusiinfo">
          <i class="busi_icon"><img src="../assets/engergy_icon.png" /></i>
          <router-link to="/energy"><i class="arrow_icon animate__animated animate__fadeInLeft animate__infinite"><img src="../assets/arrow_white.png" /></i></router-link>
          <span>清洁能源</span>
          <p>
            以城市燃气为起点，客户需求牵引下，新奥30多年来不断在清洁能源领域创新拼搏，逐步覆盖了分销、贸易、输储、生产、工程智造等天然气产业全场景，建立了完整的清洁能源产业链；以庞大的中国市场和坚实的用户基础为依托，凭借多元化海内外资源池、强大的履约交付网络和国际先进的风控体系，为客户提供安全、清洁、经济、高效、服务周到的智能化创新能源产品和服务。
          </p>
        </div>
        <img src="../assets/engergy.jpg"
             class="busiimg" />
      </li>
      <li>
        <div class="homebusiinfo">
          <i class="busi_icon"><img src="../assets/healthy_icon.png" /></i>
          <router-link to="/life"><i class="arrow_icon animate__animated animate__fadeInLeft animate__infinite"><img src="../assets/arrow_white.png" /></i></router-link>
          <span>品质生活</span>
          <p>
            以人民对美好生活的向往为牵引，新奥拓展了社区（置业）、旅游、文化和健康业务，旨在为家庭用户打造品质生活栖息地。依托新绎生活业务板块，新奥聚焦“居家”和“出行”两大场景打造康乐旅游港和来康郡，为客户提供从居家到出行全方位、高品质、智慧化的康乐居家和康乐旅游服务，引领美好生活新风尚。
          </p>
        </div>
        <img src="../assets/healthy.jpg"
             class="busiimg" />
      </li>
      <li style="margin-bottom:0;">
        <div class="homebusiinfo">
          <i class="busi_icon"><img src="../assets/internet_icon.png" /></i>
          <router-link to="/intelligent"><i class="arrow_icon animate__animated animate__fadeInLeft animate__infinite"><img src="../assets/arrow_white.png" /></i></router-link>
          <span>产业智能</span>
          <p>
            面向智能时代，新奥积极推动智能化转型，以“品质化、低碳化、智能化”的家庭和企业客户需求为牵引，建设打造了能力与能力数据运营平台恩牛网，以及好气网、泛能网、聚安网、智购、来康网、嗯噢哇等专业能力认知平台，聚焦物联传感、大模型、机器人等智能技术，打造“感知、认知、行为”一体化的智能。
          </p>
        </div>
        <img src="../assets/internet.jpg"
             class="busiimg" />
      </li>
    </ul>
    <!-- 业务模块 -->

    <!-- 底部 -->
    <Footer></Footer><!-- 底部 -->
  </div>
</template>

<script>
import Swiper from "swiper";
import Topper from "./Topper";
import Footer from "./Footer";
export default {
  components: {
    Topper,
    Footer
  },
  name: "Home",
  data () {
    return {
      newslist: []
    };
  },
  methods: {
    detail (id, type, content) {
      if (type === 1) {
        this.$router.push({ path: "newsDetail", query: { id: id } });
      } else {
        window.open(content);
      }
    },
    init () {
      if (
        localStorage.getItem("typeface") &&
        localStorage.getItem("typeface") === "繁体"
      ) {
        this.langType = "t";
        // eslint-disable-next-line no-undef
        zh_tran("t");
        this.$nextTick(() => {
          this.langType = "t";
          // eslint-disable-next-line no-undef
          zh_tran("t");
        });
      } else {
        this.langType = "s";
        // eslint-disable-next-line no-undef
        zh_tran("s");
        this.$nextTick(() => {
          this.langType = "s";
          // eslint-disable-next-line no-undef
          zh_tran("s");
        });
      }
    }
  },
  mounted () {
    new Swiper(".swiper-container", {
      loop: true,
      // 如果需要分页器
      pagination: ".swiper-pagination",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      autoplay: 3000,
      autoplayDisableOnInteraction: false, //用户操作后是否自动播放
      //   parallax: true,//允许延迟
      paginationType: "progress"
    });
    let maodian = this.$route.params.maodian;
    console.log(maodian);
    if (maodian) {
      const targetElement = document.querySelector(maodian);
      window.scrollTo({ top: targetElement.offsetTop, behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
    this.$http
      .get("/news/home/home.json")
      .then(response => {
        this.newslist = response.data;
        this.init();
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.home {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.topper {
  width: 750px;
  height: 95px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.topper .logo {
  width: 161px;
  height: 52px;
  float: left;
  margin-left: 32px;
  margin-top: 22px;
}
/* .topper .search_icon {
  width:44px;
  height: 44px;
  float: left;
  margin-left:370px;
  margin-top:22px;
} */
.topper .menu_icon {
  width: 40px;
  height: 40px;
  float: left;
  margin-left: 470px;
  /* margin-left:50px; */
  margin-top: 25px;
}
/* .autoplay-progress {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 10;
  width: 100px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--swiper-theme-color);
}

.autoplay-progress svg {
  --progress: 0;
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 10;
  width: 100%;
  height: 100%;
  stroke-width: 8px;
  stroke: var(--swiper-theme-color);
  fill: none;
  stroke-dashoffset: calc(100 * (1 - var(--progress)));
  stroke-dasharray: 100;
} */
.swiper-container {
  width: 750px;
  height: 1134px;
  margin-top: 95px;
}

.swiper-wrapper {
  width: 750px;
  height: 1134px;
}
.swiper-container .swiper-slide {
  width: 750px;
  height: 1134px;
  position: relative;
}
.swiper-container .swiper-slide img {
  width: 750px;
  height: 1134px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
.swiper-container .swiper-slide .swipertext {
  position: absolute;
  width: 600px;
  height: auto;
  overflow: hidden;
  color: #fff;
  z-index: 100;
  top: 120px;
  left: 75px;
}
.swiper-container .swiper-slide .swipertext span {
  width: 600px;
  height: auto;
  display: block;
  text-align: center;
  overflow: hidden;
  font-size: 64px;
  line-height: 80px;
  color: #fff;
  font-weight: 600;
}
.swiper-container .swiper-slide .swipertext p {
  width: 600px;
  height: auto;
  display: block;
  text-align: center;
  overflow: hidden;
  font-size: 28px;
  line-height: 50px;
  color: #fff;
  padding-top: 20px;
}
.swiper-container-horizontal > .swiper-pagination-progress {
  bottom: 0;
  top: auto;
}

.hometit {
  width: 750px;
  height: 120px;
  background: #f1f0f0;
}
.hometit span {
  display: block;
  font-size: 36px;
  color: #1d2129;
  width: 300px;
  float: left;
  margin-left: 40px;
  line-height: 120px;
  text-align: left;
  font-weight: 500;
}
.hometit a {
  display: block;
  font-size: 28px;
  color: #003f84;
  width: 300px;
  float: right;
  margin-right: 40px;
  line-height: 120px;
  text-align: right;
}
ul.homenews {
  width: 750px;
  height: auto;
  overflow: hidden;
  background: #f1f0f0;
}
ul.homenews li {
  width: 670px;
  height: 430px;
  padding: 40px;
  float: left;
  background: #fff url(../assets/newslistbg.png) no-repeat top right;
  background-size: 50%;
  margin-bottom: 30px;
}
ul.homenews li .newsdate {
  width: 670px;
  height: 100px;
  overflow: hidden;
  float: left;
}
ul.homenews li .newsdate span {
  display: block;
  font-size: 44px;
  font-family: dingding;
  font-weight: 400;
  color: #003f84;
  text-align: left;
  line-height: 55px;
}
ul.homenews li .newsdate i {
  display: block;
  font-size: 28px;
  color: #1d2129;
  font-style: normal;
  text-align: left;
  line-height: 40px;
}
ul.homenews li .newstit {
  width: 670px;
  height: 90px;
  line-height: 45px;
  font-size: 32px;
  font-weight: 600;
  color: #1d2129;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
  float: left;
  margin-top: 44px;
}
ul.homenews li .newsintro {
  width: 670px;
  height: 132px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  float: left;
  font-size: 24px;
  color: #323233;
  line-height: 33px;
  text-align: left;
  margin-top: 25px;
}
ul.homebusi {
  width: 750px;
  height: auto;
  overflow: hidden;
  float: left;
}
ul.homebusi li {
  width: 750px;
  height: auto;
  overflow: hidden;
  margin-bottom: 30px;
  float: left;
}
ul.homebusi li .homebusiinfo {
  background: #013b78;
  float: left;
  width: 690px;
  height: auto;
  overflow: hidden;
  padding: 40px;
}
ul.homebusi li .homebusiinfo .busi_icon {
  margin-top: 13px;
  width: 80px;
  height: 80px;
  float: left;
}
ul.homebusi li .homebusiinfo .busi_icon img {
  width: 80px;
  height: 80px;
}
ul.homebusi li .homebusiinfo .arrow_icon {
  width: 34px;
  height: 27px;
  float: left;
  margin-top: 35px;
  margin-left: 520px;
}
ul.homebusi li .homebusiinfo .arrow_icon img {
  width: 34px;
  height: 27px;
}
ul.homebusi li .homebusiinfo span {
  display: block;
  width: 670px;
  height: 55px;
  line-height: 55px;
  float: left;
  padding-top: 30px;
  color: #fff;
  font-family: dingding;
  text-align: left;
  font-size: 44px;
}
ul.homebusi li .homebusiinfo p {
  display: block;
  width: 670px;
  height: auto;
  overflow: hidden;
  margin-top: 30px;
  color: #fff;
  text-align: left;
  font-size: 28px;
  line-height: 40px;
  float: left;
}
ul.homebusi li img.busiimg {
  float: left;
  width: 750px;
  height: 416px;
}
</style>
<style>
.swiper-pagination-progress .swiper-pagination-progressbar {
  background: #fff !important;
}
</style>
